/**
 * @returns The path to return too after an OAuth connection redirect.
 */
const getOAuthReturnPath = () => `${window.location.pathname}${window.location.search}${window.location.hash}`;
export default getOAuthReturnPath;
